import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import TuneIcon from "@mui/icons-material/Tune";
import { type FC } from "react";

import { useFilterChipVariant } from "~/components/UI/FilterChip";

import * as Styled from "./FilterButton.styles";

export interface FilterButtonProps {
  active: boolean;
  onClick: () => void;
  count?: number;
  label?: string;
  totalCount?: number;
}

export const FilterButton: FC<FilterButtonProps> = ({
  active,
  onClick,
  count = 0,
  label = "Filters",
  totalCount,
}) => {
  const isToolbar = useFilterChipVariant() === "toolbar";

  return (
    <Styled.StyledButton onClick={onClick} active={active} toolbar={isToolbar}>
      <Styled.ButtonContent>
        <TuneIcon fontSize="small" />
        {label}
        {totalCount !== undefined && (
          <Styled.TotalCount>{totalCount} more</Styled.TotalCount>
        )}
        {!isToolbar && count > 0 && (
          <Styled.CountBadge>{count}</Styled.CountBadge>
        )}
        {active ? (
          <KeyboardArrowUpIcon
            fontSize="small"
            className="FilterButton-chevron"
          />
        ) : (
          <KeyboardArrowDownIcon
            fontSize="small"
            className="FilterButton-chevron"
          />
        )}
      </Styled.ButtonContent>
    </Styled.StyledButton>
  );
};
